module.exports = __webpack_public_path__ + "img/ai.94abff2b.png";